import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ObjectDiscussionChannel } from '@econtractor/types';
import ESpinner from 'components/others/Spinner';
import DiscussionComposer from './DiscussionComposer';
import DiscussionFeed from './DiscussionFeed';
import useObjectDiscussion from './model/useObjectDiscussion';
import { readDiscussionSort, writeDiscussionSort, type DiscussionSort } from './model/discussionSort';

interface ObjectDiscussionProps {
    objectId: number;
    channel: ObjectDiscussionChannel;
    onSeen?: () => void;
}

const ObjectDiscussion = ({ objectId, channel, onSeen }: ObjectDiscussionProps) => {
    const { t } = useTranslation(['Objects']);
    const {
        messages,
        canWrite,
        loaded,
        loadFailed,
        sending,
        failed,
        refreshing,
        send,
        refresh,
    } = useObjectDiscussion(objectId, channel, onSeen);
    const [sort, setSort] = useState<DiscussionSort>(readDiscussionSort);

    const toggleSort = () => {
        setSort((current) => {
            const next: DiscussionSort = current === 'newest' ? 'oldest' : 'newest';
            writeDiscussionSort(next);
            return next;
        });
    };

    if (!loaded) {
        return <div className="text-center py-3"><ESpinner /></div>;
    }

    return (
        <div className="object-discussion px-1 pb-3">
            <DiscussionComposer
                canWrite={canWrite}
                sending={sending}
                failed={failed}
                refreshing={refreshing}
                onSend={send}
                onRefresh={refresh}
                sort={sort}
                onToggleSort={toggleSort}
            />
            {loadFailed ? (
                <p className="text-danger mb-0">{t('discussion.loadFailed')}</p>
            ) : (
                <DiscussionFeed messages={messages} sort={sort} />
            )}
        </div>
    );
};

export default ObjectDiscussion;
